import React from "react";
import Home from "./pages/Home/Home";
export default function App() {
  return (
    <>
      <Home />
    </>
  );
}

// export default App;
